class Resource {

	static fromArray(data, list){
		let inst = new Resource(list);

		inst._id = data.item_id;
		inst._name = data.item_name;
		inst._desc = data.item_desc;
		inst._type = data.item_type;
		inst._graphic = data.graphic_id;
		inst._ownerId = data.owner_id;
		inst._ownerName = data.owner_name;
		inst._createdOn = data.created_on;
		inst._edit = data.edit;
		inst._share = data.share;
		inst._mobileSync = data.mobile;

		return inst;
	}

	constructor(list) {
		this._list = list;

		this._id = 0;
		this._name;
		this._desc;
		this._type;
		this._graphic;
		this._ownerId;
		this._ownerName;
		this._createdOn;

		this._mobileSync;
		this._clickable = true;
		this._elem = null;
	}
	
	get elem() {
		if (this._elem === null) {
			switch (this._type) {
				case 1: this._typeName = 'guide'; break;
				case 2: this._typeName = 'checklist'; break;
			}

			this._shareBtn = nav.entityType == Nav.USER
				? this._list.sharing.button(this._id)
				: null;

			this._accessBtn = nav.unit && nav.unit.isAdmin
				? this._list.access.button(this._id)
				: null;

			this._syncCheck = UI.chk();

			let mobileBtn = (nav.entityType == Nav.CIRCLE)
				? UI.iconChk(this._syncCheck, 'mobile', 22, { 'data-tip': 'above', 'aria-label': _('List on mobile') })
				: null;

			this._elem = UI.listRow([
				UI.styleChk(this._chkBox = UI.chk(
					null,
					{ 'click': () => this.select() }
				),
					{
						'click': () => {
							this._clickable = false;
						}
					}),
				UI.img('list-row-graphic', graphicSrc(this._graphic, AC.GRAPHIC_MED)),
				UI.div('flex-0', UI.icon(this._typeName, 30)),
				UI.div('flex-1', this._name),
				UI.div('flex-1', timeAgo(this._createdOn)),
				UI.div('flex-1', this._ownerName),
				UI.div('flex-0', [
					mobileBtn,
					this._tagBtn = UI.priIconBtn('tags', 18, null, {
						'aria-label': _("Select resource tags"),
						'data-tip': 'above'
					}),
					this._shareBtn,
					this._accessBtn
				], {
					'click': () => this._clickable = false
				})
			],
				{
					'click': () => {
						if (this._clickable) this.open();
						this._clickable = true;
					}
				});

			if (this._syncCheck) this._syncCheck.checked = this._mobileSync !== 0;
			// if (this._shareBtn) this._shareBtn.disabled = !this._share;

			onEv(this._syncCheck, 'change', this.setMobile.bind(this));
			onEv(this._tagBtn, 'click', this.showTags.bind(this));

		}

		return this._elem;
	}

	get id() {return this._id;}

	get checked() {return this._chkBox.checked;}
	set checked(v) {this._chkBox.checked = v;}

	open() {
		if (this._list.selection.empty && this._edit) {
			window.location.assign(`/${this._typeName}/${this._id}?${nav.params()}`);
		} 
		else {
			this.select();
		}
	}

	select() {
		this._list.selection.toggle(this);
	}

	setMobile() {
		API.upsert('items', this._id, {
			'listOnMobile': (this._syncCheck.checked ? 1 : 0)
		})
		.then(reply => {
			showError(reply);
		});
	}

	showTags() {
		this._list.getTags(this.id, this._tagBtn);
	}

	delete() {
		//TODO - delete resource function
	}
}